export const APP_BAR_HEIGHT = '64px';
export const LOGO_BAR_HEIGHT = '64px';
export const NAVBAR_WIDTH = '300px';
